const DISMISSED_KEY = "rb_cart_reminder_dismissed";
const CART_VISITED_KEY = "rb_cart_visited";
const ADDED_PAGE_KEY = "rb_cart_added_page";

function canUseSessionStorage() {
  try {
    return typeof window !== "undefined" && !!window.sessionStorage;
  } catch (e) {
    return false;
  }
}

export function hasDismissedCartReminder() {
  if (!canUseSessionStorage()) return false;
  return sessionStorage.getItem(DISMISSED_KEY) === "1";
}

export function markCartReminderDismissed() {
  if (!canUseSessionStorage()) return;
  sessionStorage.setItem(DISMISSED_KEY, "1");
}

export function hasVisitedCartThisSession() {
  if (!canUseSessionStorage()) return false;
  return sessionStorage.getItem(CART_VISITED_KEY) === "1";
}

export function markCartVisitedThisSession() {
  if (!canUseSessionStorage()) return;
  sessionStorage.setItem(CART_VISITED_KEY, "1");
}

export function markCartAddedOnCurrentPage() {
  if (!canUseSessionStorage()) return;
  sessionStorage.setItem(ADDED_PAGE_KEY, window.location.pathname);
}

export function hasJustAddedOnCurrentPage() {
  if (!canUseSessionStorage()) return false;
  return sessionStorage.getItem(ADDED_PAGE_KEY) === window.location.pathname;
}
